import React, {useContext, useEffect, useRef, useState} from 'react';
import {InboxProps} from './Inbox.props';
import './Inbox.styles.css';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { GridColDef, GridToolbarColumnsButton, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid';
import {getStatusStatistic, getTriageInboxes, updateTriageInboxes, getLatestFilter, deleteEmail, archiveEmail, sendMessageEmail, getSettings, getUsedEmail, exportTriageInboxes
} from '../../api/emailTriage';
import {SearchMenuBar} from '../../components/organisms/SearchMenuBar';
import { Images } from '../../configs/images';
import {DataTable} from '../../components/molecules/DataTable';
import { getTimeZoneName, isEditorContentEmpty, noUserDataRedirect, toPages, autoDownload } from '../../utils/common';
import moment from 'moment';
import {Button} from '../../components/atoms/Button';
import {Modal} from '../../components/atoms/Modal';
import {PageHeader} from '../../components/organisms/PageHeader';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {GlobalContext} from '../../context/GlobalState';
import {ActionsColumn} from '../../components/molecules/StyledMenu';
import {TableDropdown} from "../../components/molecules/TableDropdown";
import {DateRangePicker} from '../../components/atoms/DateRangePicker';
import {InboxDetails} from '../InboxDetails';
import {TabGroup} from "../../components/molecules/TabGroup";
import {Toast} from "../../components/atoms/Toast";
import {DropdownContent} from "../../components/molecules/DropDownContent";
import {DropDownList} from "../../components/atoms/DropDownList";
import {Tooltip, TooltipProps, tooltipClasses, styled, Box} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import {ThreatScoreTooltip} from "../../components/atoms/ThreatScoreTooltip";
import {isMobileOnly} from "react-device-detect";
import ChangeWithZone from "../../hoc/ChangeWithZone";
import {SendMailModal} from "../../components/organisms/SendMailModal";
import {Pluralize} from '../../utils/common'
import {
  ARCHIVE,
  DELETE,
  PURGE_OPTION,
  SEND_EMAIL,
  MESSAGES_STATUS_CHANGED,
  LOGGED_AZURE_TITLE, SETTING_TYPE_REPORTED_EMAILS_ACTIONS, DATA_TABLE_ITEMS_PER_PAGE,
  BULK_ACTION, EXPORT_INBOX_FAILED, OPEN_TAB_SIMILAR_MESSAGES
} from "../../constants/contants";
import {useAccount, useIsAuthenticated, useMsal} from '@azure/msal-react';
import {fetchAccessToken, loginRequest, refreshAccessToken} from "../../api/azure";

import { defaultSettings, useRoleContext } from '../../context/RoleContext';
import {RadialGraph} from '../../components/atoms/RadialGraph'
import {LoadingPage} from "../../components/organisms/LoadingPage";
import PhishClear from "../../components/services/PhishClear/PhishClear";
import {BulkActionModal} from "../../components/organisms/BulkActionModal";
import {BulkActionChanges} from "../../components/organisms/BulkActionModal/BulkActionModal.props";
import {getBulkActionOutcome} from '../../utils/bulkAction';
import {actionCategory, priorityDropdown, statusDropdown} from '../../utils/inboxStyles';
import {getSimilarWindow} from '../../utils/similarWindow';

const navigationLinks = [
  {
    name: 'Inbox'
  }
]

const inboxDetailLinks = [
  {
    name: "Inbox",
    href: "/inbox",
  },
  {
    name: "Message Details",
  },
];

const inboxDetailArchivedLinks = [
  {
    name: "Archived",
    href: "/archived",
  },
  {
    name: "Message Details",
  },
];

const actionRules:any = {
  "Action Rule 1": "Action Rule 1",
  "Action Rule 2": "Action Rule 2",
  "Action Rule 3": "Action Rule 3",
  "Action Rule 4": "Action Rule 4",
  "Action Rule 5": "Action Rule 5"

}

const tabStatus: any = {
  '0': 'Received',
  '1': 'In Review',
  '2': 'Resolved',
  '3': 'Archived',
}

const tabTitles = ['Received', 'In Review', 'Resolved'];

const SIMILAR_MESSAGES_TOOLTIP = 'The past 30 days, counting back from today.';

const PERPAGES = 10;

const defaultTabFilterValues = {
  perPages: PERPAGES,
  page: 1,
  keyword: "",
  priority: ["High", "Medium", "Low", "Unknown"],
  category: ["Threat", "Clean", "Unknown"],
  threat_analysis: ["Analysing", "Threat detected", "Undetermined", "No threat"],
  sort: "desc" ,// ASC / DESC, default is DESC,
  sortType: "priority" ,// default is date time,
};
const assignFilterValues = (prev: any, filterData: any) => ({
  ...prev,
  'priority': filterData.priority.length === defaultTabFilterValues.priority.length ? [] : filterData.priority,
  'category': filterData.category.length === defaultTabFilterValues.category.length ? [] : filterData.category,
  'threat_analysis': filterData.threat_analysis.length === defaultTabFilterValues.threat_analysis.length ? [] : filterData.threat_analysis
});

const InboxFull: React.FC<InboxProps> = ({isOpen, refKey, isArchived, setIsArchivedEmail, ...props}) => {
  const tz_name = getTimeZoneName()
  const defaultDateRange: any = {
      startDate: moment().startOf('month').toDate(),
      endDate: moment().endOf('month').toDate()
  }

  const { id } = useParams();
  const [isShowLoading, setShowLoading] = useState(false);
  const [inboxData, setInboxData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState<any>("desc");
  const [sortType, setSortType] = useState<any>("priority")
  const [perPages, setPerPages] = useState(PERPAGES);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [rowSelected, setRowSelected] = useState<any[]>([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [contentModal, setContentModal] = useState({title: '', content: '', action: '', textAgree: '', children: '', variant: ''});
  const [startPoint, setStartPoint] = useState(0);
  const [endPoint, setEndPoint] = useState(0);
  const [toastValue, setToastValue] = useState({type: '', message: '', isOpen: false, toastId: 0})
  const [statusTab, setStatusTab] = useState({'Received': 0, 'In Review': 0, 'Resolved': 0, 'Archived': 0})
  const [modalID, setModalID] = useState(1)
  const [tabValue, setValue] = useState(0);
  // Similar Messages filter: kept out of the saved filter so it always starts off after leaving the message details
  const [similarFilter, setSimilarFilter] = useState(false);
  const similarFilterRef = useRef(false);
  const updateSimilarFilter = (value: boolean) => {
    similarFilterRef.current = value;
    setSimilarFilter(value);
  };
  // similarWindow lets the API count similar messages for today's boundaries in the user's timezone
  const withSimilarFilter = (params: any) => {
    if (isArchived) {
      return params;
    }
    return {...params, similarWindow: getSimilarWindow(), ...(similarFilterRef.current ? {similar: true} : {})};
  };
  const [inboxDetail, setInboxDetail] = useState<any>({})
  // @ts-ignore
  const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};
  const zoneID:any = sessionStorage.getItem('currentZone') || localStorage.getItem('currentZone');
  const [timer, setTimer] = useState(null);
  const [timerExpire, setTimerExpire] = useState(0);
  const [triggerLoadLog, setTriggerLoadLog] = useState(1)
  // validate from name on send email modal
  const [validateFromName, setValidateFromName] = useState(false);
  const [validateToField, setValidateToField] = useState(false);
  const [validateEmailContent, setValidateEmailContent] = useState(false);

  // validate from name on send email modal
  const [validateUserName, setValidateUserName] = useState(false);
  // validate from name on send email modal
  const [validateBaseSender, setValidateBaseSender] = useState(false);
  const [filterSearchKeyword, setFilterSearchKeyword] = useState('');
  const { setting, setSetting } = useRoleContext()
  const [loadingPage, setLoadingPage] = useState(false)
  const phishClearServiceRef = useRef<any>();

  let user_id = ""
  let user_role = ""
  const localStorageUserData = localStorage.getItem('userData');
  if(localStorageUserData) {
    const parseUserData = JSON.parse(localStorageUserData)
    user_id = parseUserData["userId"]
    user_role = parseUserData["role"]
  }

  const handleChangeTitle = (e:any, type:any) => {
    const typeValue = e.target.getAttribute("value")
    const newRule = {[type]: typeValue}
    updateInbox(newRule)
  }

  const ThreatAnalysisTooltipStyle = styled(({ className, ...props }: TooltipProps) => (
      <Tooltip className={'custom-tooltip'} {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#ffffff',
      color: '#212121',
      alignItems: "center",
      maxWidth: "480px",
      borderRadius: "4px",
      boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
      fontSize: '14px',
      padding: '16px',
    },
  }));

  const columns: GridColDef[] = [
    {
      ...GRID_CHECKBOX_SELECTION_COL_DEF,
      cellClassName: 'checkbox-col'
    },
    {
      field: 'priority', headerName: 'Priority', width: 120, sortable: true,
      /* istanbul ignore next */
      renderCell: (row) => {
        return isArchived ? <TableDropdown emailId={row.id} title={row.formattedValue} variant='priority' background={priorityDropdown[row.formattedValue]['bg']} backgroundHover={priorityDropdown[row.formattedValue]['hover']} borderRadius={100}/> : <TableDropdown onClick={(e:any) => handleChangeTitle(e, row.field)} emailId={row.id} dropdownValue={setDropdownValue} title={row.formattedValue} variant='priority' background={priorityDropdown[row.formattedValue]['bg']} backgroundHover={priorityDropdown[row.formattedValue]['hover']} borderRadius={100} data={priorityDropdown}/>
      }
    },
    {
      field: 'threat_score',
      headerName: 'Threat Analysis',
      width: 160, sortable: false,
      headerClassName: 'MuiDataGrid-columnHeaderTitle',
      /* istanbul ignore next */
      renderHeader: () => (
          <Box>
            Threat Analysis
            <ThreatAnalysisTooltipStyle placement={"top"} className={"custom-tooltip"} title={<ThreatScoreTooltip />} >
              <InfoOutlinedIcon fontSize={"small"} sx={{marginLeft: '8px', position: "relative", top: "5px", cursor: "pointer"}} htmlColor={"#193051"}/>
            </ThreatAnalysisTooltipStyle>
          </Box>
      ),
      renderCell: (row) => {
        return row.formattedValue === -1 ? <Tooltip placement={"top"} title={'Scanning in progress. No threat score yet.'}>
              <span>ANALYSING...</span>
            </Tooltip> : <RadialGraph value={row.formattedValue} isToolTipHover={true} chartStyle={{stroke: 'unset'}}/>
      }
    },
    {
      field: 'status',
      headerName: 'Process Status',
      sortable: true,
      width: 120,
      /* istanbul ignore next */
      renderCell: (row) => {
        return isArchived ? <TableDropdown emailId={row.id} title={row.formattedValue} variant='status' color='#212121' background={statusDropdown[row.formattedValue]['bg'] } backgroundHover={statusDropdown[row.formattedValue]['hover']} borderRadius={2} padding={'4px 4px 4px 8px'} /> : <TableDropdown onClick={(e:any) => handleChangeTitle(e, row.field)} emailId={row.id} dropdownValue={setDropdownValue} title={row.formattedValue} variant='status' color='#212121' background={statusDropdown[row.formattedValue]['bg'] } backgroundHover={statusDropdown[row.formattedValue]['hover']} borderRadius={2} padding={'4px 4px 4px 8px'} data={statusDropdown}/>
      }
    },

    { field: 'category',
      headerName: 'Category',
      width: 120,
      sortable: true,
      /* istanbul ignore next */
      renderCell: (row) => {
        return isArchived ? <TableDropdown emailId={row.id} title={row.formattedValue} variant='category' color='#212121' background='transparent' backgroundHover='transparent' borderRadius={100}/> : <TableDropdown onClick={(e:any) => handleChangeTitle(e, row.field)} emailId={row.id} dropdownValue={setDropdownValue} title={row.formattedValue} variant='category' color='#212121' background='transparent' backgroundHover='transparent' borderRadius={100} data={actionCategory}/>
      }
    },
    { field: 'email_from',
      headerName: 'From (Email)',
      width: 260,
      sortable: false,
      renderCell: (row) => {
        return <Tooltip placement={"top"} title={row.formattedValue}>
          <span className={'MuiDataGrid-cellContent'}>{row.formattedValue}</span>
        </Tooltip>
      }
    },
    {
      field: 'subject',
      headerName: 'Subject',
      width: isOpen ? 450 : 300,
      flex: isArchived ? undefined : 1,
      minWidth: isArchived ? undefined : 200,
      sortable: true,
      renderCell: (row) => {
        return <Tooltip placement={"top"} title={row.formattedValue}>
          <span className={'MuiDataGrid-cellContent'}>{row.formattedValue}</span>
        </Tooltip>
      }
    },
    {
      field: 'reported_at',
      headerName: 'Reported at',
      width: 120,
      renderCell: (row) => {
        return (<div>
          <span>{moment.utc(row.formattedValue, 'DD/MM/YYYY hh:mm:ss').tz(tz_name).format('DD/MM/YYYY')}</span>
          <br/>
          <span>{moment.utc(row.formattedValue, 'DD/MM/YYYY hh:mm:ss').tz(tz_name).format('hh:mm A')}</span>
        </div>)
      }
    },
    {
      field: 'reported_by',
      headerName: 'Reported by (Email)',
      width: 220,
      sortable: false,
      renderCell: (row) => {
        return <Tooltip placement={"top"} title={row.formattedValue}>
          <span className={'MuiDataGrid-cellContent'}>{row.formattedValue}</span>
        </Tooltip>
      }
    },
  ];

  if (!isArchived) {
    columns.push({
      field: 'similar_count',
      headerName: 'Similar Messages',
      width: 150,
      sortable: false,
      // same header title style as the other custom headers (e.g. Threat Analysis)
      headerClassName: 'MuiDataGrid-columnHeaderTitle',
      /* istanbul ignore next */
      renderHeader: () => (
        <Box className={'similar-header-title'}>
          <span>Similar{' '}<br/>Messages</span>
          <Tooltip placement={"top"} title={SIMILAR_MESSAGES_TOOLTIP}>
            <svg className={'similar-info-icon'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" data-testid={'similar-info-icon'}>
              <path d="M7.3125 4.65625V3.3125H6V4.65625H7.3125ZM7.3125 10V6H6V10H7.3125ZM1.9375 1.96875C3.25 0.65625 4.82292 0 6.65625 0C8.48958 0 10.0521 0.65625 11.3438 1.96875C12.6563 3.26042 13.3125 4.82292 13.3125 6.65625C13.3125 8.48958 12.6563 10.0625 11.3438 11.375C10.0521 12.6667 8.48958 13.3125 6.65625 13.3125C4.82292 13.3125 3.25 12.6667 1.9375 11.375C0.645833 10.0625 0 8.48958 0 6.65625C0 4.82292 0.645833 3.26042 1.9375 1.96875Z" fill="currentColor"/>
            </svg>
          </Tooltip>
        </Box>
      ),
      renderCell: (row) => {
        const openSimilarMessages = (event: any) => {
          // only the number opens Message Details, on the Similar Messages tab
          event.stopPropagation();
          handleDoubleClickItem({field: row.field, id: row.id, row: row.row}, OPEN_TAB_SIMILAR_MESSAGES);
        };
        return row.formattedValue >= 2 ? <span
          className={'similar-count-link'}
          data-testid={'similar-count-link'}
          role={'link'}
          tabIndex={0}
          onClick={openSimilarMessages}
          onDoubleClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.key === 'Enter' && openSimilarMessages(event)}
        >{row.formattedValue}</span> : <span/>
      }
    });
  }

  if (isArchived) {
    columns.push({
      field: 'archived_at',
      headerName: 'Archived at',
      width: 180,
      renderCell: (row) => {
        return (<div className={`${isArchived ? 'last-cell' : ''}`}>
          <span>{moment.utc(row.formattedValue, 'YYYY-MM-DD hh:mm:ss').tz(tz_name).format('DD/MM/YYYY')}</span>
          <br/>
          <span>{moment.utc(row.formattedValue, 'YYYY-MM-DD hh:mm:ss').tz(tz_name).format('hh:mm A')}</span>
        </div>)
      }
    })
  }

  const formatAMPM = (date:any) => {
    var hours = date.hours();
    var minutes = date.minute();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  const mobileColumns: GridColDef[] = [
    {
      ...GRID_CHECKBOX_SELECTION_COL_DEF,
      cellClassName: 'checkbox-col',
    },
    {
      field: 'email_from',
      headerName: 'From (Email)',
      sortable: false,
      cellClassName: 'email-content',
      renderCell: (rowCell) => {
        return <div className='info-mobile-row' style={{padding: '10px 0', fontSize: '14px'}}>
          <div className='row first-row'>
            <b>{rowCell.row.email_from}</b>
            <span className={`priority ${rowCell.row.priority}`} style={{borderRadius: '100px', color: '#fff', padding: '4px 8px'}}>{rowCell.row.priority}</span>
          </div>
          <div className='row second-row'>
            <div className='subject'>{rowCell.row.subject}</div>
            <div className='datetime'>
              <span className='date'>{moment.utc(rowCell.row.date_scanned).tz(tz_name).format('DD/MM/YYYY')}</span>
              <span className='time'>{formatAMPM(moment(rowCell.row.date_scanned))}</span>
            </div>
          </div>
          <div className='row third-row'>
            <label>Status: <span style={{background: '#EDEDED', borderRadius: '2px', color: '#212121', padding:'2px 8px', fontWeight:'600'}}>{rowCell.row.status}</span>&nbsp; | &nbsp;</label>
            <label>Category: <b>{rowCell.row.category}</b></label>
          </div>
        </div>
      }
    }
  ];

  const [dateRange, setDateRange] = useState({
    startDate: defaultDateRange.startDate,
    endDate: defaultDateRange.endDate,
  })
  const defaultFilter: any = {
    tabs: [
      ...tabTitles.map(_ => defaultTabFilterValues),
    ],
    archived: defaultTabFilterValues,
    startDate: moment.utc(dateRange.startDate).format('YYYY-MM-DD HH:mm:ss'),
    endDate: moment.utc(dateRange.endDate).format('YYYY-MM-DD HH:mm:ss'),
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [dropdownValue, setDropdownValue] = useState<any>('');
  const open = Boolean(anchorEl);
  const [filterStatus, setFilterStatus] = useState<any>({status: isArchived ? ['Archived'] : ['Received']});
  const [inboxStatistic, setInboxStatistic] = useState<any>({});

  const [selectedItems, setSelectedItems] = useState<any>({});
  const [inboxEvent, setInboxEvent] = useState<any>({id: id || '', selectedEmail: ''});

  const [usedEmail, setUsedEmail] = useState<any>(null)

  const assignSelectedItems = (values: any) => setSelectedItems((prev: any) => assignFilterValues(prev, values));

  const getFilterData = () => JSON.parse(sessionStorage.getItem('filter') || '{}');
  const getCurrentFilter = (filterData: any) => {
    if(!filterData['tabs']) {
      filterData['tabs'] = {
        [tabValue]: {}
      }
    }
    const tab = isArchived ? filterData.archived : filterData['tabs'][tabValue];
    const { startDate, endDate } = filterData;
    return Object.assign(tab || {}, { startDate, endDate });
  };
  const saveFilter = (filter: any) => sessionStorage.setItem('filter', JSON.stringify(filter));

  const resetFilters = (resetAll=false) => {
    updateSimilarFilter(false);
    const filterData = getFilterData();
    const dates = {
      startDate: filterData.startDate,
      endDate: filterData.endDate,
    };
    if (resetAll) {
      Object.assign(filterData, defaultFilter);
    } else {
      const currentTabFilter = getCurrentFilter(filterData);
      Object.assign(currentTabFilter, defaultTabFilterValues);
    }
    saveFilter(filterData);

    setFilterSearchKeyword(defaultTabFilterValues.keyword);
    setPerPages(defaultTabFilterValues.perPages);
    setDateRange({
      startDate: filterData.startDate,
      endDate: filterData.endDate,
    });
    assignSelectedItems(defaultTabFilterValues);

    const params = {
      ...defaultTabFilterValues,
      ...filterStatus,
      ...dates,
    }
    setCurrentPage(1);
    setInboxData([]);
    getInboxes(1, params);
    getStatusTab(params);
  }

  const showActionsDropdown = (event: React.MouseEvent<HTMLElement>) => {
    const emailId:any = event.currentTarget.getAttribute('data-emailid');
    const rowId = document.querySelector('[data-id="'+emailId+'"]');
    if(rowId) {
      rowId.classList.add('focusing')
    }
    handleGetUsedEmail({settingType: "default_email"})
    setAnchorEl(event.currentTarget);
    getInboxDetail(emailId)
  };
  const hideActionsDropdown = () => {
    const gridRows = document.querySelectorAll('.MuiDataGrid-row');
    if(gridRows) {
      for(let i = 0; i < gridRows.length; i++) {
        gridRows[i].classList.remove('focusing');
      }
    }
    setAnchorEl(null);
  };

  const [columnData, setColumnData] = useState<any>(null)

  const getFilterColumn = (data:object) => {
    return getLatestFilter(data).then((result) => {
      const a = result.data;
      if (a === "nodata") {
        sessionStorage.setItem("dynamicColumn", JSON.stringify({}));
        setColumnData({})
      } else {
        sessionStorage.setItem("dynamicColumn", a.dynamic_column);
        setColumnData(JSON.parse(a.dynamic_column))
      }
      return a;
    });
  }

  const loadDataTable = () => {
    const userData = localStorage.getItem('userData');
    if (userData === null) {
      noUserDataRedirect()
    } else {
      const userId = JSON.stringify(JSON.parse(userData)["userId"]);

        const filter = sessionStorage.getItem("filter");
      if (filter === null) {
        const filterParams = { ...defaultFilter, ...filterStatus };
        getInboxes(1, filterParams);
        getStatusTab(filterParams);
        getFilterColumn({"userId": userId});
        sessionStorage.setItem("filter", JSON.stringify(filterParams));
      } else {
        const filterData = JSON.parse(filter);

        const currentTabFilter = getCurrentFilter(filterData);
        assignSelectedItems(currentTabFilter);
        getFilterColumn({"userId": userId});
        getStatusTab(currentTabFilter);
        getInboxes(1, { ...currentTabFilter, ...filterStatus });
      }
      getSettings().then((response) => {
        const newSettings = { ...defaultSettings };
        response.data.forEach((item: any) =>
          Object.assign(newSettings, { [item.setting_type]: item.setting_value })
        );
        setSetting(response.data.length > 0 ? newSettings : defaultSettings);
      }).catch((e) => {
        console.error(e)
      });
    }
  }

  useEffect(() => {
    loadDataTable()
    const dataParams:any = {settingType: "default_email"}
    handleGetUsedEmail(dataParams)
  },[])
  const navigate = useNavigate();
  const location = useLocation();

  const { globalDispatch, globalState } = useContext(GlobalContext);
  const isMS365 = globalState.ms365

  useEffect(() => {
    resetFilters(true);
    if(isArchived){
      setFilterStatus({status: ['Archived']})
    }
  }, [globalState.currentZone]);

  const rowParams = (rowUpdated:any, newRule:any) => {
    if(rowUpdated) {
      return {
        "emailId": rowUpdated.email_id,
        "category": newRule?.category || rowUpdated.category,
        "priority": newRule?.priority || rowUpdated.priority,
        "status": newRule?.status || rowUpdated.status
      }
    }
  }

  const updateInbox = (newRule:any) => {
    const rowEmailId = anchorEl?.getAttribute('data-emailid') || dropdownValue;
    let rowUpdated:any;
    if(rowEmailId) {
      rowUpdated = inboxData.find((row:any) => row.email_id === rowEmailId.toString());
    }
    if(rowUpdated) {
      const params = rowParams(rowUpdated, newRule)
      const inboxUpdated:any = inboxData.map((row:any) => {
        return row.email_id === rowEmailId ? { ...row, priority: params?.priority, status: params?.status, category: params?.category }: row;
      });
      setInboxData(inboxUpdated);

      return updateTriageInboxes(params).then((result) => {
        if(result.status === 200) {
          setRowSelected([])
        }
      })
    } else {
      const selectedRowsData = rowSelected.map((id:any) => inboxData.find((row:any) => row.email_id === id));
      let inboxesUpdated:any;

      inboxesUpdated = inboxData.map((rowData:any) => {
        const found = selectedRowsData.find((rowS: any) => rowS.email_id === rowData.email_id);
        if (found) {
          const rowParam = rowParams(found, newRule)
          rowData = Object.assign(rowData, {priority: rowParam?.priority, status: rowParam?.status, category: rowParam?.category});
          updateTriageInboxes(rowParam).then((result) => {
            if(result.status === 200) {
              setRowSelected([])
            }
          })
        }
        return rowData;
      });
      setInboxData(inboxesUpdated)
    }
  }

  const getInboxes = (page: number, params: any, perPageNav?: number, onSort?: string, sortTypeTable?: string) => {
    let data = null;
    setShowLoading(true);
    params["page"] = page;
    params["sort"] = onSort || sort;
    params["perPages"] = perPageNav || perPages;
    params["sortType"] = sortTypeTable || sortType;

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    const timers: any = setTimeout( async () => {
       data = await getTriageInboxes(withSimilarFilter(params));
        if(data && data.status === 200) {
        const a = data.data;
        setShowLoading(false);
        setInboxData(a.list);
        setTotalRows(a.totalItems);
        setStartPoint(a.startItemsPerPage);
        setEndPoint(a.endItemsPerPage)
        setTotalPages(a.maxPage);
        setInboxStatistic(a.statistic)
        hideActionsDropdown()
      }
    }, 800);
    setTimer(timers);
  };

  const getStatusTab = (params: any) => {
    getStatusStatistic(withSimilarFilter(params)).then((result) => {
      const data = result.data;
      setStatusTab({'Received': data.totalStaReceived, 'In Review': data.totalStaReview, 'Resolved': data.totalStaResolved, 'Archived': data.totalArchive})
    })
  }

  const setActiveFilter = (item:any) => {
    const status = { status: [item] };
    setFilterStatus(status);

    const filterData = getFilterData();
    Object.assign(filterData, status);
    saveFilter(filterData);
    const currentTabFilter = getCurrentFilter(filterData);

    assignSelectedItems(currentTabFilter);
    setFilterSearchKeyword(currentTabFilter.keyword);
    setPerPages(currentTabFilter.perPages)

    getInboxes(1, {...currentTabFilter, ...status}, currentTabFilter.perPages);
    setCurrentPage(1);
    getStatusTab(currentTabFilter);
  }

  const handleFilter = (item: any, type: any) => {
    setSelectedItems((prev: any) => {
      return ({
        ...prev,
        [type]: item,
      });
    });
    const filterData = getFilterData();
    const currentTabFilter = getCurrentFilter(filterData);

    if (typeof item === 'object') {
      if (item.length > 0) {
        Object.assign(currentTabFilter, { [type]: item });
      } else {
        Object.assign(currentTabFilter, {
          [type]: isArchived ? defaultFilter.archived[type] : defaultFilter['tabs'][tabValue][type]
        });
      }
    }
    saveFilter(filterData);

    setCurrentPage(1);
    setInboxData([]);
    getInboxes(1, { ...currentTabFilter, ...filterStatus });
    getStatusTab(currentTabFilter);
  };

  const handleToggleSimilarFilter = () => {
    updateSimilarFilter(!similarFilterRef.current);
    const currentTabFilter = getCurrentFilter(getFilterData());

    setCurrentPage(1);
    setInboxData([]);
    getInboxes(1, { ...currentTabFilter, ...filterStatus });
    getStatusTab(currentTabFilter);
  };

  const handleClearFilter = (type: any) => {
    setSelectedItems((prev:any) => {
      return ({
        ...prev,
        [type]: [],
      })
    });
  };

  const handlePageChange = (page: number) => {
    const currentFilter = getCurrentFilter(getFilterData());
    setCurrentPage(page);
    getInboxes(page, {...currentFilter, ...filterStatus});
    getStatusTab(currentFilter);
  }

  const handlePerRowsChange = (e: any) => {
    const value = parseInt(e.target.value);
    setPerPages(value);
    const filterData = getFilterData();
    const currentFilter = getCurrentFilter(filterData);
    Object.assign(currentFilter, { perPages: value });
    saveFilter(filterData);

    setCurrentPage(1);
    getInboxes(1, {...currentFilter, ...filterStatus}, value);
    getStatusTab(currentFilter);
  };

  const actionOtherData:any = isArchived ? {
    "Delete": DELETE,
    } : setting[SETTING_TYPE_REPORTED_EMAILS_ACTIONS] && isMS365 ? {
      "BulkAction": BULK_ACTION,
      "SendMail": SEND_EMAIL,
      "Purge": PURGE_OPTION,
      "Archive": ARCHIVE,
      "Delete": DELETE,
    } : {
      "BulkAction": BULK_ACTION,
      "SendMail": SEND_EMAIL,
      "Archive": ARCHIVE,
      "Delete": DELETE,
    }

  const customToolbar = () => {
    // @ts-ignore
    return (
      <div className='toolbar'>
        <div className={"left-toolbar " + (disabledActions ? 'hide-left-toolbar': 'show-left-toolbar')}>
          {disabledActions ? '' :
            <div className={"rows-selected"}>
              <Button
                linkIcon={Images.CloseIcon}
                margin={"0 13px 0  0"}
                backgroundColor={"transparent"}
                variant={'only-icon'}
                fontSize={14}
                width={24}
                iconWidth={14}
                iconHeigth={14}
                color={'#011111'}
                onClick={() => setRowSelected([])}
              />
              <span>{totalRowsSelected} Selected</span>
            </div>
          }
          <DropDownList
            className={`${isArchived ? 'is_archived' : ''}`}
            width={124}
            height={36}
            border={"none"}
            variantDropdown={'actions-dropdown-inbox'}
            selectedTitle={'Actions'}
            disabled={(disabledActions)}
            children={<DropdownContent open={true} inboxActionMenu menuData={rowSelected} actionOtherData={actionOtherData} handleOpenSendMail={handleSendMail} handleDeleteMail={handleActionDelete} handleArchiveMail={handleArchiveMail} handlePurgeMail={handlePurgeMail} handleBulkAction={handleOpenBulkAction}/>}
          />
        </div>
        <div className={"right-toolbar"}>
          {!isArchived && inboxData.length > 0 ?
            <Tooltip title={'Export data'}>
              <IconButton
                className='export-inbox-button'
                id='export-inbox-button'
                data-testid='export-inbox-button'
                onClick={handleExportInbox}
              >
                <DownloadIcon/>
              </IconButton>
            </Tooltip> : null}
          {!isMobileOnly ? <GridToolbarColumnsButton startIcon={null} onResize={undefined} onResizeCapture={undefined} key={undefined}
                                    id={undefined} title={undefined} type={undefined} defaultChecked={undefined}
                                    defaultValue={undefined} suppressContentEditableWarning={undefined}
                                    suppressHydrationWarning={undefined} accessKey={undefined}
                                    contentEditable={undefined} contextMenu={undefined} dir={undefined}
                                    draggable={undefined} hidden={undefined} lang={undefined} nonce={undefined}
                                    placeholder={undefined} slot={undefined} spellCheck={undefined}
                                    translate={undefined} radioGroup={undefined} role={undefined} about={undefined}
                                    datatype={undefined} inlist={undefined} prefix={undefined} property={undefined}
                                    resource={undefined} typeof={undefined} vocab={undefined} autoCapitalize={undefined}
                                    autoCorrect={undefined} autoSave={undefined} itemProp={undefined}
                                    itemScope={undefined} itemType={undefined} itemID={undefined} itemRef={undefined}
                                    results={undefined} security={undefined} unselectable={undefined}
                                    inputMode={undefined} is={undefined} aria-activedescendant={undefined}
                                    aria-atomic={undefined} aria-autocomplete={undefined} aria-busy={undefined}
                                    aria-checked={undefined} aria-colcount={undefined} aria-colindex={undefined}
                                    aria-colspan={undefined} aria-controls={undefined} aria-current={undefined}
                                    aria-describedby={undefined} aria-details={undefined} aria-disabled={undefined}
                                    aria-dropeffect={undefined} aria-errormessage={undefined} aria-expanded={undefined}
                                    aria-flowto={undefined} aria-grabbed={undefined} aria-haspopup={undefined}
                                    aria-hidden={undefined} aria-invalid={undefined} aria-keyshortcuts={undefined}
                                    aria-label={undefined} aria-labelledby={undefined} aria-level={undefined}
                                    aria-live={undefined} aria-modal={undefined} aria-multiline={undefined}
                                    aria-multiselectable={undefined} aria-orientation={undefined} aria-owns={undefined}
                                    aria-placeholder={undefined} aria-posinset={undefined} aria-pressed={undefined}
                                    aria-readonly={undefined} aria-relevant={undefined} aria-required={undefined}
                                    aria-roledescription={undefined} aria-rowcount={undefined} aria-rowindex={undefined}
                                    aria-rowspan={undefined} aria-selected={undefined} aria-setsize={undefined}
                                    aria-sort={undefined} aria-valuemax={undefined} aria-valuemin={undefined}
                                    aria-valuenow={undefined} aria-valuetext={undefined}
                                    dangerouslySetInnerHTML={undefined} onCopy={undefined} onCopyCapture={undefined}
                                    onCut={undefined} onCutCapture={undefined} onPaste={undefined}
                                    onPasteCapture={undefined} onCompositionEnd={undefined}
                                    onCompositionEndCapture={undefined} onCompositionStart={undefined}
                                    onCompositionStartCapture={undefined} onCompositionUpdate={undefined}
                                    onCompositionUpdateCapture={undefined} onFocus={undefined}
                                    onFocusCapture={undefined} onBlur={undefined} onBlurCapture={undefined}
                                    onChange={undefined} onChangeCapture={undefined} onBeforeInput={undefined}
                                    onBeforeInputCapture={undefined} onInput={undefined} onInputCapture={undefined}
                                    onReset={undefined} onResetCapture={undefined} onSubmit={undefined}
                                    onSubmitCapture={undefined} onInvalid={undefined} onInvalidCapture={undefined}
                                    onLoad={undefined} onLoadCapture={undefined} onError={undefined}
                                    onErrorCapture={undefined} onKeyDown={undefined} onKeyDownCapture={undefined}
                                    onKeyPress={undefined} onKeyPressCapture={undefined} onKeyUp={undefined}
                                    onKeyUpCapture={undefined} onAbort={undefined} onAbortCapture={undefined}
                                    onCanPlay={undefined} onCanPlayCapture={undefined} onCanPlayThrough={undefined}
                                    onCanPlayThroughCapture={undefined} onDurationChange={undefined}
                                    onDurationChangeCapture={undefined} onEmptied={undefined}
                                    onEmptiedCapture={undefined} onEncrypted={undefined} onEncryptedCapture={undefined}
                                    onEnded={undefined} onEndedCapture={undefined} onLoadedData={undefined}
                                    onLoadedDataCapture={undefined} onLoadedMetadata={undefined}
                                    onLoadedMetadataCapture={undefined} onLoadStart={undefined}
                                    onLoadStartCapture={undefined} onPause={undefined} onPauseCapture={undefined}
                                    onPlay={undefined} onPlayCapture={undefined} onPlaying={undefined}
                                    onPlayingCapture={undefined} onProgress={undefined} onProgressCapture={undefined}
                                    onRateChange={undefined} onRateChangeCapture={undefined} onSeeked={undefined}
                                    onSeekedCapture={undefined} onSeeking={undefined} onSeekingCapture={undefined}
                                    onStalled={undefined} onStalledCapture={undefined} onSuspend={undefined}
                                    onSuspendCapture={undefined} onTimeUpdate={undefined}
                                    onTimeUpdateCapture={undefined} onVolumeChange={undefined}
                                    onVolumeChangeCapture={undefined} onWaiting={undefined} onWaitingCapture={undefined}
                                    onAuxClick={undefined} onAuxClickCapture={undefined} onClick={undefined}
                                    onClickCapture={undefined} onContextMenu={undefined}
                                    onContextMenuCapture={undefined} onDoubleClick={undefined}
                                    onDoubleClickCapture={undefined} onDrag={undefined} onDragCapture={undefined}
                                    onDragEnd={undefined} onDragEndCapture={undefined} onDragEnter={undefined}
                                    onDragEnterCapture={undefined} onDragExit={undefined} onDragExitCapture={undefined}
                                    onDragLeave={undefined} onDragLeaveCapture={undefined} onDragOver={undefined}
                                    onDragOverCapture={undefined} onDragStart={undefined} onDragStartCapture={undefined}
                                    onDrop={undefined} onDropCapture={undefined} onMouseDown={undefined}
                                    onMouseDownCapture={undefined} onMouseEnter={undefined} onMouseLeave={undefined}
                                    onMouseMove={undefined} onMouseMoveCapture={undefined} onMouseOut={undefined}
                                    onMouseOutCapture={undefined} onMouseOver={undefined} onMouseOverCapture={undefined}
                                    onMouseUp={undefined} onMouseUpCapture={undefined} onSelect={undefined}
                                    onSelectCapture={undefined} onTouchCancel={undefined}
                                    onTouchCancelCapture={undefined} onTouchEnd={undefined}
                                    onTouchEndCapture={undefined} onTouchMove={undefined} onTouchMoveCapture={undefined}
                                    onTouchStart={undefined} onTouchStartCapture={undefined} onPointerDown={undefined}
                                    onPointerDownCapture={undefined} onPointerMove={undefined}
                                    onPointerMoveCapture={undefined} onPointerUp={undefined}
                                    onPointerUpCapture={undefined} onPointerCancel={undefined}
                                    onPointerCancelCapture={undefined} onPointerEnter={undefined}
                                    onPointerEnterCapture={undefined} onPointerLeave={undefined}
                                    onPointerLeaveCapture={undefined} onPointerOver={undefined}
                                    onPointerOverCapture={undefined} onPointerOut={undefined}
                                    onPointerOutCapture={undefined} onGotPointerCapture={undefined}
                                    onGotPointerCaptureCapture={undefined} onLostPointerCapture={undefined}
                                    onLostPointerCaptureCapture={undefined} onScroll={undefined}
                                    onScrollCapture={undefined} onWheel={undefined} onWheelCapture={undefined}
                                    onAnimationStart={undefined} onAnimationStartCapture={undefined}
                                    onAnimationEnd={undefined} onAnimationEndCapture={undefined}
                                    onAnimationIteration={undefined} onAnimationIterationCapture={undefined}
                                    onTransitionEnd={undefined} onTransitionEndCapture={undefined} value={undefined}
                                    form={undefined} autoFocus={undefined} formAction={undefined}
                                    formEncType={undefined} formMethod={undefined} formNoValidate={undefined}
                                    formTarget={undefined} name={undefined}/> : null}
        </div>
      </div>
    )
  }

  const paginationComponent = () => {

    const perRowsPages = DATA_TABLE_ITEMS_PER_PAGE;
    const pageItems = toPages(totalPages);
    const nextDisabled = currentPage === pageItems.length || !totalRows ? 'disabled': '';
    const previousDisabled = currentPage === 1 || !totalRows ? 'disabled': '';

    return <nav className='pagination'>
      <div className='pagination-flex'>

        <span className='rowPerPages' style={{marginRight: 8}}>Rows per page</span>
        <select value={perPages} onChange={handlePerRowsChange} style={{width: 59}}>
          {
            perRowsPages.map(page => <option key={page} value={page}>{page}</option>)
          }
        </select>

        <span className='totalRows' style={{marginRight: 32, marginLeft: 32}}> {startPoint}-{endPoint} of {totalRows}  </span>

        <ul className="pagination-numbers">
          <li data-testid="first-page" onClick={() => handlePageChange(1)} className={'first-page ' + previousDisabled}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path><path fill="none" d="M24 24H0V0h24v24z"></path></svg></li>
          <li data-testid="previous-page" onClick={() => handlePageChange(currentPage - 1)} className={'previous-page ' + previousDisabled}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg></li>
          <li data-testid="next-page" onClick={() => handlePageChange(currentPage + 1)} className={'next-page ' + nextDisabled}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg></li>
          <li data-testid="last-page" onClick={() => handlePageChange(pageItems.length)}  className={'last-page ' + nextDisabled}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path><path fill="none" d="M0 0h24v24H0V0z"></path></svg></li>
        </ul>
      </div>
    </nav>
  }

  const onSelectedRowsChange = (rows:any) => {
    const selectedRowsData = rows.map((id:any) => inboxData.find((row:any) => row.email_id === id));
    setRowSelected(selectedRowsData);
  }

  const onSort = (model:any , _: any) => {
    const currentTabFilter = getCurrentFilter(getFilterData());
    setSort(model?.length !== 0 ? model[0].sort : 'desc');
    setSortType(model?.length !== 0 ? model[0].field : 'date');
    getInboxes(
      1,
      {...currentTabFilter, ...filterStatus},
      perPages,
      model?.length !== 0 ? model[0].sort : 'desc',
      model?.length !== 0 ? model[0].field : 'date'
    );
    getStatusTab(currentTabFilter);
  };

  const onSearchInboxByKeywords = (event:any) => {
    if(event.keyCode === 13) {
      const filterData = getFilterData();
      const currentTabFilter = getCurrentFilter(filterData);
      Object.assign(currentTabFilter, { keyword: event.target.value });
      saveFilter(filterData);
      getInboxes(1, { ...currentTabFilter, ...filterStatus });
    }
  }

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleDoubleClickItem = (event:any, openTab?: string) =>{
    const fields = ['category', '__check__', 'status', 'priority']
    if(!fields.includes(event.field)) {
      globalDispatch({
        type: 'UPDATE_SELECTED_EMAIL',
        payload: event.row
      })
      setInboxEvent({id: event.id, selectedEmail: event.row})
      setIsArchivedEmail(event.row.is_archive)
      if(event.row.is_archive){
        navigate('/archived/' + event.id, {
          state: {
            selectedEmail: event.row
          }
        })
      } else {
        navigate('/inbox/' + event.id, {
          state: {
            selectedEmail: event.row,
            ...(openTab ? {openTab} : {})
          }
        })
      }

    }
  }

  const handleApplyDateRange = (picker:any) => {
    const { startDate, endDate } = picker;
    setDateRange({
      startDate: startDate,
      endDate: endDate,
    });

    const filterData = getFilterData();
    Object.assign(filterData, { startDate, endDate });
    saveFilter(filterData);

    const currentTabFilter = getCurrentFilter(filterData);
    setCurrentPage(1);
    setInboxData([]);
    getInboxes(1, { ...currentTabFilter, ...filterStatus });
    getStatusTab(currentTabFilter);
  };

  const handleActionDelete = (params?:any, page?: string) => {
    const emailItems:any = []
    let deleteParams:any = {
      emailItems: []
    }
    let deleteMessage:any = ''
    const rowEmailId = anchorEl?.getAttribute('data-emailid') || dropdownValue;
    if(rowSelected.length !== 0 && ((typeof params) === 'object' && params.length === 0 && rowEmailId === '')){
      // multi checkbox
      rowSelected.map((id:any) => emailItems.push({
        "email_id": id.toString(),
        "zone_id": zoneID.toString()
      }));
      deleteParams['emailItems'] = emailItems
      deleteMessage = emailItems.length > 1 ? `${emailItems.length.toString()} messages` : `${emailItems.length.toString()} message`
    } else if(rowEmailId.length !== 0 && (typeof params) === 'object'){
      // action column
      deleteParams['emailItems'].push({
        "email_id": rowEmailId,
        "zone_id": zoneID.toString()
      })
      deleteMessage = `${deleteParams['emailItems'].length.toString()} message`
    } else {
      // action in message details
      deleteParams['emailItems'] = params
      deleteMessage = 'message'
    }
    setAnchorEl(null)
    return deleteEmail(deleteParams).then((result:any) => {
      setModalID(modalID + 1)
      setToastValue({type: 'success', message: `Deleted ${deleteMessage} successfully!`, isOpen: true, toastId: modalID})
      if (params && isArchived){
        setInboxEvent({id: '', selectedEmail: ''})
        navigate('/archived')
      } else {
        navigate('/inbox')
      }
      loadDataTable()
    });
  }

  const handleEmailChange = (params?:any) => {
    loadDataTable()
  }

  const handleArchiveMail = (params?:any) => {
    const emailItems:any = []
    let archiveParams:any = {
      archived_at: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      itemsArchive: []
    }
    let archiveMessage:any = ''
    const rowEmailId = anchorEl?.getAttribute('data-emailid') || dropdownValue;
    if(rowSelected.length !== 0 && ((typeof params) === 'object' && params.length === 0 && rowEmailId === '')){
      // multi checkbox
      rowSelected.map((id:any) => emailItems.push({
        "email_id": id.toString(),
      }));
      archiveParams['itemsArchive'] = emailItems
      archiveMessage = emailItems.length > 1 ? `${emailItems.length.toString()} messages` : `${emailItems.length.toString()} message`
    } else if(rowEmailId.length !== 0 && (typeof params) === 'object'){
      // action column
      archiveParams['itemsArchive'].push({
        "email_id": rowEmailId,
      })
      archiveMessage = `${archiveParams['itemsArchive'].length.toString()} message`
    } else {
      // action in message details
      archiveParams['itemsArchive'] = params
      archiveMessage = 'message'
    }
    setAnchorEl(null)
    return archiveEmail(archiveParams).then((result:any) => {
      setModalID(modalID + 1)
      setToastValue({type: 'success', message: `Archived ${archiveMessage} successfully!`, isOpen: true, toastId: modalID})
      if (params){
        navigate('/inbox')
      }
      loadDataTable()
    });
  }

  const getInboxDetail = (params:any) => {
    inboxData.map((row:any) => {
      return row.email_id === params ? setInboxDetail({
        emailId: params,
        subject: row?.subject,
        reportedBy: row?.reported_by,
        priority: row?.priority,
        threatAnalysis: row?.threat_score,
        status: row?.status,
        category: row?.category,
        scanResult: row?.scan_result,
        sender: row?.email_from,
        recipient: row?.to,
        threat_score: row?.threat_score
      }) : row;
    });
  }

  const handleGetUsedEmail = (dataParams:object) => {
    getUsedEmail(dataParams).then((res) => {
      setUsedEmail(res.data)
    }).catch((res) => {
      console.log(res)
    })
  }

  // effect when clicking checkbox
  useEffect(() => {
    const params = rowSelected.join('')
    if (rowSelected.length === 1){
      getInboxDetail(params)
    } else {
      setInboxDetail({})
    }
  }, [rowSelected])

  // effect when clicking archived page
  useEffect(() => {
    if(isArchived){
      setActiveFilter('Archived')
      if(!(location.pathname.split('/archived/').length === 2)){
        setInboxEvent({id: '', selectedEmail: ''})
      }
    } else {
      setActiveFilter(tabStatus[tabValue]);
    }
  }, [isArchived, tabValue])

  const defaultParams: any = {
    subject: inboxDetail?.subject || '',
    from: userData.email,
    fromName: 'No-Reply',
    to: [],
    cc: [],
    originalReporter: true,
    statusToResolved: true,
    content: '',
    base64Data: '',
    originalEmail: '',
    recipients: [],
    reportedBy: inboxDetail?.reportedBy || '',
    userName: '',
    baseSender: null,
    threat_score: inboxDetail?.threat_score || 0,
    category: inboxDetail?.category || '',
    status: inboxDetail?.status || '',
  }

  const [paramSendMail, setParamSendMail] = useState(defaultParams)
  const [openSendMail, setOpenSendMail] = useState(false)
  const similarSendTargetRef = useRef<string | null>(null);
  const handleSimilarSendMail = (message: any) => {
    similarSendTargetRef.current = String(message.email_id);
    setInboxDetail({
      emailId: message.email_id,
      subject: message.subject,
      reportedBy: message.reported_by,
      priority: message.priority,
      category: message.category,
      status: message.status,
      threatAnalysis: message.threat_score,
      threat_score: message.threat_score,
    });
    handleGetUsedEmail({settingType: 'default_email'});
    setParamSendMail({
      ...defaultParams,
      subject: message.subject || '',
      reportedBy: message.reported_by || '',
      threat_score: message.threat_score || 0,
      category: message.category || '',
      status: message.status || '',
      baseSender: usedEmail && usedEmail.length !== 0 ? usedEmail : '',
      fromName: usedEmail && usedEmail.length !== 0 ? usedEmail?.from_name : 'No-Reply',
    });
    setOpenSendMail(true);
  };
  const closeSendMail = () => {
    similarSendTargetRef.current = null;
    setOpenSendMail(!openSendMail);
    setValidateToField(false);
    setValidateFromName(false);
    setValidateEmailContent(false);
    setValidateUserName(false);
    setValidateBaseSender(false);
  }

  const handleSendMail = () => {
    similarSendTargetRef.current = null;
    setOpenSendMail(!openSendMail)
    setAnchorEl(null)
    hideActionsDropdown()
    setParamSendMail(() => {
      return ({
        ...defaultParams,
        baseSender: usedEmail && usedEmail.length !== 0 ? usedEmail : "",
        fromName: usedEmail && usedEmail.length !== 0 ? usedEmail?.from_name : "No-Reply",
      })
    });
  }
  const validatePopupSendMail = () => {
    const editorValue = document.getElementsByClassName("jodit-wysiwyg");
    if (editorValue) {
      paramSendMail['content'] = editorValue[0].innerHTML;
    }

    const isMissingTo = paramSendMail.to.length === 0;
    const isMissingContent = isEditorContentEmpty(paramSendMail.content);
    const isMissingSenderId = !paramSendMail.baseSender?.mail_sender_id;
    const isMissingFromName = !paramSendMail.fromName.trim();

    if (isMissingTo || isMissingContent || isMissingSenderId || isMissingFromName) {
      setValidateBaseSender(isMissingSenderId);
      setValidateFromName(isMissingFromName);
      setValidateToField(isMissingTo);
      setValidateEmailContent(isMissingContent);
      setModalID(modalID + 1);
      setToastValue({
        type: 'error',
        message: 'Please complete the required fields.',
        isOpen: true,
        toastId: modalID
      });
    } else {
      sendMail(paramSendMail);
      handleClose();
      setValidateToField(false);
      setValidateFromName(false);
      setValidateEmailContent(false);
      setValidateUserName(false);
      setValidateBaseSender(false);
    }
  }

  const sendMail:any = (paramSendMail:object) => {
    const changeStatusParams = {
      emailId: inboxDetail?.emailId || '',
      status: 'Resolved',
      priority: inboxDetail?.priority || '',
      category: inboxDetail?.category || ''
    }
    paramSendMail['emailId'] = inboxDetail?.emailId || '';
    paramSendMail['zoneId'] = zoneID.toString();
    paramSendMail['settingType'] = "default_email";
    paramSendMail['settingValue'] = Boolean(true);

    setOpenSendMail(false);
    return sendMessageEmail(paramSendMail).then((result:any) => {
      const similarTarget = similarSendTargetRef.current;
      similarSendTargetRef.current = null;
      setModalID(modalID + 1)
      setToastValue({type: 'success', message: 'Email sent successfully.', isOpen: true, toastId: modalID})
      handleGetUsedEmail({settingType: "default_email"})
      if (similarTarget !== null && similarTarget === String(inboxEvent.id)) {
        navigate('/inbox');
      } else if (similarTarget) {
        setTriggerLoadLog((value) => value + 1);
      }
      if(paramSendMail['statusToResolved']){
        return updateTriageInboxes(changeStatusParams).then((result:any) => {
          loadDataTable()
          if (!similarTarget) {
            setTriggerLoadLog((value) => value + 1)
          }
        });
      }
    });
  };

  const handlePurgeMail = (params?:any, actionFrom?:any) => {
    const emailItems:any = []
    let deleteParams:any = {
      emailItems: []
    }
    let paramsData:any
    let emailParams:any
    const rowEmailId = anchorEl?.getAttribute('data-emailid') || dropdownValue;

    emailParams = inboxDetail
    emailParams['recipient'] = inboxDetail['recipient']?.split('<')[1] ? inboxDetail['recipient']?.split('<')[1]?.split('>')[0] : inboxDetail['recipient']

    if(rowSelected.length !== 0 && ((typeof params) === 'object' && params.length === 0 && rowEmailId === '')){
      // multi checkbox
      rowSelected.map((id:any) => emailItems.push({
        "email_id": id.toString(),
        "zone_id": zoneID.toString()
      }));
      deleteParams['emailItems'] = emailItems
    } else if(rowEmailId.length !== 0 && (typeof params) === 'object'){
      // action column
      deleteParams['emailItems'].push({
        "email_id": rowEmailId,
        "zone_id": zoneID.toString()
      })
    } else {
      // action in message details
      deleteParams['emailItems'] = params
      const emailContent = params[0].email_content
      emailParams = {
        emailId: params[0].email_id,
        subject: emailContent?.subject,
        reportedBy: emailContent?.reportedBy,
        sender: emailContent?.email,
        recipient: emailContent?.to,
        priority: emailContent?.priority,
        status: emailContent?.status,
        category: emailContent?.category,
        scanResult: emailContent?.scanResult,
      }
    }

    setAnchorEl(null)
    paramsData = {
      emailId: deleteParams['emailItems'][0].email_id,
      zoneId: zoneID,
      service_type: "purge",
      emailAction: userData.email,
      nameAction: userData.fullName,
      emailContent: emailParams,
      upn: null,
      tid: null
    }

    const changeStatusPriority = {
      emailId: deleteParams['emailItems'][0].email_id,
      status: 'Resolved',
      priority: paramsData.emailContent.priority,
      category: paramsData.emailContent.category
    }

    /// PHISH CLEAR FUNCTION
    if(phishClearServiceRef && phishClearServiceRef.current) {
      const onPurgeSuccess = async () => {
        await updateTriageInboxes(changeStatusPriority);
        loadDataTable();
        setTriggerLoadLog(triggerLoadLog + 1);
      }

      const onPurgeError = () => {}
      const service = actionFrom === 'InboxDetails' ? 'inbox_details_phish_clear' : 'inbox_phish_clear'
      const sourceId = actionFrom === 'InboxDetails' ?  paramsData['emailId']: ''
      phishClearServiceRef.current.performPhishClear({
        data: paramsData,
        service: service,
        sourceId: sourceId
      }, onPurgeSuccess, onPurgeError)
    }
  }

  const handleSimilarPhishClear = (message: any, onAccepted: () => void) => {
    const recipient = message.to?.split('<')[1]
      ? message.to.split('<')[1].split('>')[0]
      : message.to;
    const emailContent = {
      emailId: message.email_id,
      subject: message.subject,
      reportedBy: message.reported_by,
      sender: message.email_from,
      recipient,
      priority: message.priority,
      status: message.status,
      category: message.category,
      scanResult: message.scan_result,
    };
    phishClearServiceRef.current?.performPhishClear({
      data: {
        emailId: message.email_id,
        zoneId: zoneID,
        service_type: 'purge',
        emailAction: userData.email,
        nameAction: userData.fullName,
        emailContent,
        upn: null,
        tid: null,
      },
      service: 'inbox_phish_clear',
      sourceId: '',
    }, async () => {
      await updateTriageInboxes({
        emailId: message.email_id,
        status: 'Resolved',
        priority: message.priority,
        category: message.category,
      });
      loadDataTable();
      setTriggerLoadLog((value) => value + 1);
      onAccepted();
    }, () => {});
  };


  const [openBulkAction, setOpenBulkAction] = useState(false);
  const [bulkActionTargets, setBulkActionTargets] = useState<any[]>([]);
  const [bulkActionApplying, setBulkActionApplying] = useState(false);

  const handleOpenBulkAction = (items?: any) => {
    const targets = (items && items.length ? items : rowSelected).filter(Boolean);
    if (targets.length === 0) {
      return;
    }
    setBulkActionTargets(targets);
    setOpenBulkAction(true);
    hideActionsDropdown();
  };

  const handleCloseBulkAction = () => {
    if (bulkActionApplying) {
      return;
    }
    setOpenBulkAction(false);
  };

  const handleApplyBulkAction = (changes: BulkActionChanges) => {
    const targets = bulkActionTargets.map((emailId) => emailId.toString());
    setBulkActionApplying(true);
    return updateTriageInboxes({
      emailIds: targets,
      ...changes,
    }).then((result) => {
      const outcome = getBulkActionOutcome(targets, result.data || {});
      const newModalID = modalID + 1;
      setModalID(newModalID);
      setBulkActionApplying(false);
      setOpenBulkAction(false);
      setRowSelected(outcome.failedIds);
      setToastValue({type: outcome.type, message: outcome.message, isOpen: true, toastId: newModalID});
      loadDataTable();
      return result;
    }).catch(() => {
      const outcome = getBulkActionOutcome(targets, {
        failed: targets.map((email_id) => ({email_id, code: 'UPDATE_FAILED', message: 'Inbox message could not be updated'})),
      });
      const newModalID = modalID + 1;
      setModalID(newModalID);
      setBulkActionApplying(false);
      setOpenBulkAction(false);
      setRowSelected(outcome.failedIds);
      setToastValue({type: outcome.type, message: outcome.message, isOpen: true, toastId: newModalID});
    });
  };

  const handleExportInbox = () => {
    const filterData = getFilterData();
    const currentTabFilter = getCurrentFilter(filterData);
    const params = withSimilarFilter({...currentTabFilter, ...filterStatus, page: 1, sort, perPages, sortType});
    setLoadingPage(true);
    exportTriageInboxes(params).then((res) => {
      const download_url = res?.data?.download_url;
      const newModalID = modalID + 1;
      if (download_url) {
        autoDownload(download_url);
      } else {
        setModalID(newModalID);
        setToastValue({type: 'error', message: EXPORT_INBOX_FAILED, isOpen: true, toastId: newModalID});
      }
      setLoadingPage(false);
    }).catch(() => {
      const newModalID = modalID + 1;
      setModalID(newModalID);
      setToastValue({type: 'error', message: EXPORT_INBOX_FAILED, isOpen: true, toastId: newModalID});
      setLoadingPage(false);
    });
  };

  const totalRowsSelected =  rowSelected.length
  const disabledActions = rowSelected.length === 0;
  const handleSimilarActionCompleted = (action: 'Archive' | 'Delete', count: number) => {
    const verb = action === 'Archive' ? 'Archived' : 'Deleted';
    const messages = count > 1 ? `${count} messages` : '1 message';
    const nextToastId = modalID + 1;
    setModalID(nextToastId);
    setToastValue({
      type: 'success', message: `${verb} ${messages} successfully!`, isOpen: true, toastId: nextToastId,
    });
    loadDataTable();
  };
  const handleSimilarBulkActionCompleted = () => {
    loadDataTable();
  };
  const aoColumns = <ActionsColumn isArchive={isArchived} inboxActionMenu menuData={inboxData} rowSelected={[inboxDetail?.emailId]} open={open} showActionsDropdown={showActionsDropdown} actionRules={actionRules} hideActionsDropdown={hideActionsDropdown} anchorEl={anchorEl} handleDelete={handleActionDelete} handleArchive={handleArchiveMail} handleSendMail={handleSendMail} handlePurgeMail={handlePurgeMail} actionOtherData={actionOtherData} handleBulkAction={handleOpenBulkAction}/>
  const isInboxPage = inboxEvent['id'] && window.location.pathname !== '/inbox'
  useEffect(() => {
    if (isInboxPage) {
      updateSimilarFilter(false);
    }
  }, [isInboxPage]);
  const isArchivedPage = inboxEvent['id'] && isArchived
  return <div className='inbox-page page-content-wrapper'>
    <PageHeader

      setInboxEvent={setInboxEvent} pageTitle={isInboxPage ? 'Message Details' : isArchived ? 'Archived' : 'Inbox'}
      breadCrumbData={isInboxPage ? (isArchivedPage ? inboxDetailArchivedLinks : inboxDetailLinks) : navigationLinks}
      children={isInboxPage ? '' : <DateRangePicker
        start={dateRange.startDate}
        end={dateRange.endDate}
        fontSize={'14px'}
        color={'#011111'}
        colorText={'#011111'}
        width={'165px'}
        height={'36p'}
        cssClass={'daterange-input'}
        dates={dateRange}
        handleApplyDateRange={handleApplyDateRange}
        maxSpan={{'years': 2}}
      />}/>
    {
      isInboxPage || isArchivedPage ? <InboxDetails
        emailId={inboxEvent['id']}
        selectedRowEmail={inboxEvent['selectedEmail']}
        handleDelete={(params:any) => handleActionDelete(params, 'InboxDetails')}
        handleArchiveMail={handleArchiveMail}
        tabValue={tabValue}
        rowSelected={rowSelected}
        actionOtherData={actionOtherData}
        handleSendMail={handleSendMail}
        handleActionDelete={handleActionDelete}
        handleEmailChanged={handleEmailChange}
        handlePurgeMail={(params: any) => handlePurgeMail(params, "InboxDetails")}
         similarActions={{
           showPhishClear: Boolean(setting[SETTING_TYPE_REPORTED_EMAILS_ACTIONS] && isMS365),
           onSendMail: handleSimilarSendMail,
           onPhishClear: handleSimilarPhishClear,
           onActionCompleted: handleSimilarActionCompleted,
            onBulkActionCompleted: handleSimilarBulkActionCompleted,
         }}
        triggerLoadLog={triggerLoadLog}
      /> : <div >

        <div className='page-content-body'>
          {/*<SummaryStatistics setActiveFilter={setActiveFilter} active={filterStatus.type} arrList={inboxStatistic || []} onFilter={handleFilter}></SummaryStatistics>*/}
          <div className='inbox-content'>
            {isMobileOnly ? <div className='search-inbox'>
              <SearchMenuBar
                selectedItems={selectedItems}
                resetFilter={resetFilters}
                handleEnterSearch={onSearchInboxByKeywords}
                onFilter={handleFilter}
                searchInputValue={filterSearchKeyword}
                setSearchInputValue={setFilterSearchKeyword}
                onClearFilter={handleClearFilter}
                similarFilter={isArchived ? undefined : {active: similarFilter, onToggle: handleToggleSimilarFilter}}
              />
            </div> : null}
            {isArchived ? null : <TabGroup setValue={setValue} tabValue={tabValue} tabTitles={tabTitles} tabContents={[]} setActiveFilter={setActiveFilter} statistic={statusTab}/>}
            {!isMobileOnly ? <div className='search-inbox'>
              <SearchMenuBar
                selectedItems={selectedItems}
                resetFilter={resetFilters}
                handleEnterSearch={onSearchInboxByKeywords}
                onFilter={handleFilter}
                searchInputValue={filterSearchKeyword}
                setSearchInputValue={setFilterSearchKeyword}
                onClearFilter={handleClearFilter}
                similarFilter={isArchived ? undefined : {active: similarFilter, onToggle: handleToggleSimilarFilter}}
              />
            </div> : null}
            <div className={
              isArchived || isMobileOnly
                ? 'inbox-datatable'
                : 'inbox-datatable inbox-datatable-with-actions'
            }>
              {columnData && <DataTable columns={isMobileOnly ? mobileColumns : columns}
                         checkNoFilterColumn ={columnData}
                         data={inboxData}
                         filterData={columnData}
                         rowCount={totalRows}
                         onSelectionModelChange={setRowSelected}
                         CustomPagination={paginationComponent}
                         onChangeRowsPerPage={onSelectedRowsChange}
                         onRowDoubleClick={handleDoubleClickItem}
                         toolbar={customToolbar}
                         actionsColumn={!isMobileOnly && aoColumns}
                         selectionModel={rowSelected}
                         onSortModelChange={onSort}
                         loadingTable={isShowLoading}
                         checkboxSelection={true}
                         pagination={true}
                         initialSortCol={'priority'}
              />}
            </div>
          </div>
        </div>


      </div>
    }
    <Modal
           idModal='modal-phish-clear'
           openDialog={openDialog}
           variant={contentModal.variant}
           title={contentModal.title}
           content={contentModal.content}
           textAgree={contentModal.textAgree}
           actionAgree={() => {
             handleClose()
           }}
           onClose={handleClose}
           children={contentModal.children}
    />
    <Modal idModal='modal-send-mail'
           variant='send-mail'
           disableEnforceFocus={true}
           openDialog={openSendMail}
           title={'Send email'}
           actionAgree={validatePopupSendMail}
           actionCancel={closeSendMail}
           textAgree={'Send'}
           textCancel={'Cancel'}
           onClose={closeSendMail}
           handleOnChange={(e:any) => setParamSendMail(() => {
             return  ({
               ...paramSendMail,
               'statusToResolved': e.target.checked,
             })
           })}
    >

      {inboxDetail && <SendMailModal
          defaultParams={defaultParams}
          paramSendMail={paramSendMail}
          setParamSendMail={setParamSendMail}
          scanResult={{'scan-result': inboxDetail?.threatAnalysis >= 70 ? "Infected" : ""}}
          validateFromName={validateFromName}
          setValidateFromName={setValidateFromName}
          fromNameError={'This field is required.'}
          validateToField={validateToField}
          setValidateToField={setValidateToField}
          validateEmailContent={validateEmailContent}
          setValidateEmailContent={setValidateEmailContent}
          editorError={'This field is required.'}
          validateUserName={validateUserName}
          setValidateUserName={setValidateUserName}
          validateBaseSender={validateBaseSender}
          setValidateBaseSender={setValidateBaseSender}
          isMessageDownload={true}
          useTemplates
      />}
    </Modal>
    <BulkActionModal
      open={openBulkAction}
      applying={bulkActionApplying}
      selectedCount={bulkActionTargets.length}
      onCancel={handleCloseBulkAction}
      onApply={handleApplyBulkAction}
    />
    <PhishClear ref={phishClearServiceRef}/>
    <LoadingPage open={loadingPage}/>
    <Toast isOpen={toastValue.isOpen} type={toastValue.type} message={toastValue.message} toastId={toastValue.toastId} autoHideDuration={2000}/>
  </div>
};

export const Inbox = ChangeWithZone(InboxFull);
